import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import CheckBox from '../../../components/common/CheckBox';
import BulletList from '../../../components/common/BulletList';
import { ContentWrapper } from '../../../asset/styled/PreviousEmploymentStyled';

const PrivacyConsentStep = ({ onAgree }) => {
  const { t } = useTranslation('previousEmployment');
  const [isAgreed, setIsAgreed] = useState(false);

  const handleAgree = () => {
    if (isAgreed) {
      onAgree();
    }
  };

  const handleCheckboxChange = () => {
    setIsAgreed(!isAgreed);
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      {/* 콘텐츠 박스 */}
      <ContentWrapper>
        {/* 제목 */}
        {/* [필수] 개인정보 수집·이용 동의서 */}
        <Typography variant="body1Bold">{t('privacyConsentSection.contentTitle')}</Typography>

        {/* 본문 내용 */}
        <div className="displayFlexColumn" style={{ gap: '20px' }}>
          {/* 서비스명 */}
          {/* [상품/서비스명: 연말정산 문서 자동분석(OCR)·AI 자동입력 서비스] */}
          <Typography variant="body2Medium">
            {t('privacyConsentSection.serviceName')}
          </Typography>

          {/* 서비스 설명 */}
          <Typography variant="body2Medium">
            {t('privacyConsentSection.serviceDescription')}
          </Typography>

          {/* 1. 개인정보 수집·이용 목적 */}
          <div>
            <Typography variant="body2Medium">
              {t('privacyConsentSection.purpose.title')}
            </Typography>
            <BulletList markerColor="var(--GrayScale-900)">
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.purpose.item1')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.purpose.item2')}
                </Typography>
              </li>
            </BulletList>
          </div>

          {/* 2. 수집·이용 항목 */}
          <div>
            <Typography variant="body2Medium">{t('privacyConsentSection.items.title')}</Typography>
            <Typography variant="body2Medium" style={{ marginTop: '8px' }}>
              {t('privacyConsentSection.items.subtitle')}
            </Typography>
            <BulletList markerColor="var(--GrayScale-900)">
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.items.generalInfo')}
                </Typography>
                <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-700)' }}>
                  {t('privacyConsentSection.items.generalInfoDesc')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.items.yearendInfo')}
                </Typography>
                <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-700)' }}>
                  {t('privacyConsentSection.items.yearendInfoDesc')}
                </Typography>
              </li>
            </BulletList>
            <Typography variant="body2Medium" style={{ marginTop: '8px', color: 'var(--GrayScale-700)' }}>
              {t('privacyConsentSection.items.notice')}
            </Typography>
          </div>

          {/* 3. 보유 및 이용 기간 */}
          <div>
            <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-900)' }}>
              {t('privacyConsentSection.period.title')}
            </Typography>
            <BulletList markerColor="var(--GrayScale-900)">
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.period.item1')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.period.item2')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.period.item3')}
                </Typography>
              </li>
            </BulletList>
          </div>

          {/* 4. 동의 거부 권리 및 불이익 */}
          <div>
            <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-900)' }}>
              {t('privacyConsentSection.refusal.title')}
            </Typography>
            <BulletList markerColor="var(--GrayScale-900)">
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.refusal.item1')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.refusal.item2')}
                </Typography>
              </li>
            </BulletList>
          </div>

          {/* 5. AI 자동입력 기능 안내 및 책임 고지 */}
          <div>
            <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-900)' }}>
              {t('privacyConsentSection.aiNotice.title')}
            </Typography>
            <BulletList markerColor="var(--GrayScale-900)">
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.aiNotice.item1')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.aiNotice.item2')}
                </Typography>
              </li>
              <li>
                <Typography variant="body2Medium">
                  {t('privacyConsentSection.aiNotice.item3')}
                </Typography>
              </li>
            </BulletList>
          </div>
        </div>
      </ContentWrapper>

      {/* 체크박스 */}
      <CheckBox
        size="large"
        checked={isAgreed}
        onChange={handleCheckboxChange}
        label={t('privacyConsentSection.checkboxLabel')}
        style={{ alignItems: 'flex-start' }}
      />

      {/* 동의하고 AI 반영하기 버튼 */}
      <Button
        color="primary"
        onClick={handleAgree}
        disabled={!isAgreed}
        value={t('privacyConsentSection.agreeButton')}
      />
    </div>
  );
};

export default PrivacyConsentStep;
